'use client'

import React from 'react'
import { cx } from 'class-variance-authority'
import SelectReactSelect, { components, OptionProps } from 'react-select'

import {
  ClearIndicator,
  DropdownIndicator,
  MenuList,
  overflowProps,
  reactSelectStyles,
  reactSelectTheme,
} from './select.config'

interface SelectProps extends React.ComponentProps<typeof SelectReactSelect> {
  overflow?: boolean
}

type CustomOption = {
  value: string
  label: string
  type?: string
  icon?: React.ReactNode
  className?: string
  onClick?: () => void
}

type CustomGroupAction = {
  label: string
  options: CustomOption[]
  type?: string
  icon?: React.ReactNode
  className?: string
  onClick?: () => void
}

const CustomOption = (
  props: OptionProps<CustomOption, false, CustomGroupAction>,
) => {
  const { data, getStyles } = props
  const styles = getStyles('option', props)
  return (
    <div
      onClick={data?.onClick}
      style={styles as any}
      className={cx(
        '!cursor-pointer !flex !flex-row gap-1.5 items-center',
        data?.className,
      )}
    >
      {data?.icon}
      {data?.label}
    </div>
  )
}

const Option = (props: OptionProps<CustomOption, false, CustomGroupAction>) => {
  if (props.data.type === 'custom') {
    return <CustomOption {...props} />
  }

  return <components.Option {...props} />
}

export const Select = ({ overflow, theme, styles, ...props }: SelectProps) => {
  return (
    <SelectReactSelect
      styles={styles ?? reactSelectStyles}
      theme={theme ?? reactSelectTheme}
      components={{ ClearIndicator, DropdownIndicator, Option, MenuList }}
      placeholder={props.placeholder}
      noOptionsMessage={({ inputValue }) =>
        inputValue ? 'Aucun résultat' : 'Entrez votre recherche'
      }
      {...overflowProps(overflow)}
      {...props}
    />
  )
}
